import React, { useEffect } from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga4";
import { notification, checkEmptyObject } from "../../services";
import history, { navigateToLogin } from "../../history";
import confirmModal from "../../services/confirmModal";
import { selectLoadedUser } from "../../routes/Auth/auth.ducks";
import { selectHiddenAdIds, hideAd, unhideAd } from "../../routes/Hidden/hidden.ducks";
import { getIconUrl } from "../../services/asset";
import styles from "./hideAdButton.scss";
import { HashTag } from "../../models";
import { summaryInterface, UserI } from "../../typings/interfaces";

interface HideAdButtonProps {
  adSummary: summaryInterface;
  user: UserI | null;
  hiddenAdIds: string[];
  hideAd: (adId: string) => Promise<any>;
  unhideAd: (adId: string) => Promise<any>;
}

const HideAdButton: React.FC<HideAdButtonProps> = ({
  adSummary,
  user,
  hiddenAdIds,
  hideAd,
  unhideAd
}) => {
  const isLoggedIn = user && checkEmptyObject(user);
  const isOwnAd = isLoggedIn && adSummary && user.userId === adSummary.creatorId;
  const isAdHidden = hiddenAdIds.includes(adSummary.id);


  const handleClick = async (e: React.MouseEvent) => {

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (!isLoggedIn) {
      navigateToLogin(window.location.href + HashTag.adHide);
      return;
    }

    if (isAdHidden) {
      confirmModal.show({
        title: "Želiš prikazati ovaj oglas?",
        okText: "Nastavi",
        cancelText: "Odustani",
        iconType: "NaN",
        onOk: async () => {
          try {
            await unhideAd(adSummary.id);
            notification.show("Oglas je prikazan.");

            ReactGA.event({
              category: "Sakrivanje oglasa",
              action: "Click",
              label: "Prikazan oglas"
            });
          } catch (error) {
            notification.showError("Greška prilikom prikazivanja oglasa.");
          }
        },
        onCancel: () => {
          ReactGA.event({
            category: "Sakrivanje oglasa",
            action: "Click",
            label: "Odustao od prikazivanja"
          });
        },
        children: "Kada prikažeš ovaj oglas, ponovo će ti se prikazivati u rezultatima pretrage i sličnim oglasima."
      });
    } else {
      // Handle hide

      confirmModal.show({
        title: "Želiš sakriti ovaj oglas?",
        okText: "Nastavi",
        cancelText: "Odustani",
        iconType: "NaN",
        onOk: async () => {
          try {
            await hideAd(adSummary.id);
            notification.show("Oglas je sakriven.");

            ReactGA.event({
              category: "Sakrivanje oglasa",
              action: "Click",
              label: "Sakriven oglas"
            });
          } catch (error) {
            notification.showError("Greška prilikom sakrivanja oglasa.");
          }
        },
        onCancel: () => {
          ReactGA.event({
            category: "Sakrivanje oglasa",
            action: "Click",
            label: "Odustao od sakrivanja"
          });
        },
        children: "Kada sakriješ ovaj oglas, više ti se neće prikazivati u rezultatima pretrage niti u sličnim oglasima."
      });
    }
  };

   useEffect(() => {
    const adHide = history.location.hash === HashTag.adHide;

    if (adHide && !isOwnAd && !isAdHidden) {
      handleClick(null);
    }

    if (adHide) history.replace(history.location.pathname);
  }, [isOwnAd, isAdHidden]);

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={handleClick}
      className={`${styles.hideButton} ${isAdHidden ? styles.hidden : ''}`}
      title={isAdHidden ? "Prikaži oglas" : "Sakrij oglas"}
    >
      <img
        src={getIconUrl(isAdHidden ? "eye-visible.svg" : "eye-invisible.svg")}
        alt={isAdHidden ? "Show ad" : "Hide ad"}
        className={styles.icon}
      />
      <span className={styles.text}>
        {isAdHidden ? "Prikaži" : "Sakrij"}
      </span>
    </span>
  );
};

export default connect(
  (state: any) => ({
      user: selectLoadedUser(state),
      hiddenAdIds: selectHiddenAdIds(state)
    }),
  {
    hideAd,
    unhideAd
  }
)(HideAdButton);


// WEBPACK FOOTER //
// ./src/components/HideAdButton/HideAdButton.tsx